import { F0Box, F0Text } from '@factorialco/f0-react'

const PeriodOverviewTab = () => {
  return (
    <F0Box display="flex" justifyContent="center" alignItems="center" padding="3xl">
      <F0Text variant="body" color="secondary" content={'Coming soon'} />
    </F0Box>
  )
}

export default PeriodOverviewTab
